import { forwardRef } from 'react';
import ReCaptchaV2 from 'react-google-recaptcha';

import styled from 'styled-components';

import { Flex, Text, spacing, useStylesFor } from '@sine/sine-ui-components';

const StyledText = styled(Text)`
  font-size: 11px;
`;

const ReCaptchaContainer = styled.div`
  .grecaptcha-badge {
    visibility: hidden;
  }

  max-width: 740px;
  padding: ${spacing(2)};
  margin: 0 auto;

  ${() => useStylesFor('largeTablet').andSmaller`
    max-width: 430px;
    overflow: hidden;
  `};
`;

const ReCaptcha = forwardRef<ReCaptchaV2>((_, ref) => (
  <ReCaptchaContainer>
    <ReCaptchaV2 ref={ref} size='invisible' sitekey={window.env.REACT_APP_GOOGLE_RECAPTCHA_API} />
    {/* Legal */}
    <Flex justifyContent='center' direction='column' alignItems='center'>
      <StyledText variant='small' colorVariant='text68'>
        This site is protected by reCAPTCHA and the Google&nbsp;
        <a href='https://policies.google.com/privacy'>Privacy Policy</a> and&nbsp;
        <a href='https://policies.google.com/terms'>Terms of Service</a> apply. The site you are visiting is requesting
        this content to complete your check-in. The data you submit will be sent to the administrator of this site.
        Honeywell is not responsible for the privacy or security practices of its customers, including this site.
        Powered by Honeywell Forge Visitor Management&nbsp;
        <a href='https://www.honeywell.com/us/en/privacy-statement'>Privacy Policy</a> |&nbsp;
        <a href='https://www.honeywell.com/us/en/legal/legal-terms'>Terms of Use</a>.
      </StyledText>
    </Flex>
  </ReCaptchaContainer>
));

ReCaptcha.displayName = 'ReCaptcha';

export default ReCaptcha;
